import React, { useState } from 'react';
import Pagination from '../../../common/Pagination';
import ReputationIcon from '../subparts/ReputationIcon';
import { REPUTATION_SECTION_THEMES, getReputationAvatarTheme } from '../subparts/reputationTheme';
import {
    formatReputationDate,
    getCommentStatusMeta,
    getPatientInitials,
} from '../subparts/reputationQuery';

function CommentsTab({ patientComments, onPageChange }) {
    const [currentPage, setCurrentPage] = useState(0);
    const comments = patientComments?.content || [];
    const totalElements = patientComments?.totalElements ?? 0;

    const handlePageChange = (page) => {
        setCurrentPage(page);
        onPageChange(page);
    };

    return (
        <div>
            <div className="reputation-section">
                <div className="reputation-section__heading">
                    <ReputationIcon icon="bi-chat-dots" theme={REPUTATION_SECTION_THEMES.comments} size="md" />
                    <div>
                        <h2 className="reputation-section__title">Patient Comments</h2>
                        <p className="reputation-section__subtitle">
                            Review comments submitted through your reputation page
                        </p>
                    </div>
                </div>
                <div className="reputation-section__actions">
                    <span className="reputation-chip">
                        <ReputationIcon icon="bi-chat-dots" theme="purple" size="xs" />
                        {totalElements} comment{totalElements === 1 ? '' : 's'}
                    </span>
                </div>
            </div>

            {comments.length > 0 ? (
                <>
                    <div className="d-flex flex-column gap-3">
                        {comments.map((comment, index) => {
                            const statusMeta = getCommentStatusMeta(comment.status);

                            return (
                                <div key={comment.id} className="ecx-page-list-item reputation-comment-card">
                                    <div className="reputation-comment-card__header">
                                        <div className="d-flex align-items-center gap-3 min-width-0">
                                            <ReputationIcon
                                                round
                                                theme={getReputationAvatarTheme(comment.patientId, index)}
                                                size="md"
                                                className="reputation-avatar"
                                            >
                                                {getPatientInitials(comment.firstName, comment.lastName)}
                                            </ReputationIcon>
                                            <div className="min-width-0">
                                                <h3 className="reputation-activity-item__title mb-0">
                                                    {comment.firstName} {comment.lastName}
                                                </h3>
                                                <small className="text-muted">
                                                    Patient ID: {comment.patientId?.slice(0, 8) || '—'}...
                                                </small>
                                            </div>
                                        </div>
                                        <span className={statusMeta.className}>
                                            <i className={`bi ${statusMeta.icon}`}></i>
                                            {statusMeta.label}
                                        </span>
                                    </div>
                                    <p className="reputation-comment-card__notes">{comment.notes || '—'}</p>
                                    <div className="reputation-comment-card__footer">
                                        <span>
                                            <i className="bi bi-clock me-1"></i>
                                            {formatReputationDate(comment.createdAt)}
                                        </span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    {patientComments.totalPages > 1 && (
                        <div className="ecx-page-pagination border-top pt-3 mt-3">
                            <Pagination
                                currentPage={currentPage}
                                totalPages={patientComments.totalPages}
                                onPageChange={handlePageChange}
                                totalElements={totalElements}
                                pageSize={patientComments.pageable?.pageSize || 10}
                            />
                        </div>
                    )}
                </>
            ) : (
                <div className="ecx-page-empty">
                    <ReputationIcon
                        icon="bi-chat-dots"
                        theme={REPUTATION_SECTION_THEMES.comments}
                        size="lg"
                        className="reputation-empty-icon"
                    />
                    <h3 className="h6 fw-bold text-dark mb-1">No patient comments</h3>
                    <p className="mb-0 small">Patient comments will appear here once they are submitted.</p>
                </div>
            )}
        </div>
    );
}

export default CommentsTab;
